import { WorkOSPermission as Permission } from "@/data/types";

const checkPermission = <P>(permissions: P[] | unknown, probe: P): boolean => {
  if (!Array.isArray(permissions)) {
    return false;
  }

  return permissions.includes(probe);
};

export const canCreateSKU = (permissions?: Permission[]) => {
  const probe = Permission.CREATE_SKU;
  return checkPermission(permissions, probe);
};

export const canEditSKU = (permissions?: Permission[]) => {
  const probe = Permission.EDIT_SKU;
  return checkPermission(permissions, probe);
};

export const canExportOwners = (permissions?: Permission[]) => {
  const probe = Permission.EXPORT_OWNER;
  return checkPermission(permissions, probe);
};

export const canDeleteTag = (permissions?: Permission[]) => {
  const probe = Permission.DELETE_TAG;
  return checkPermission(permissions, probe);
};

export const canViewAnalytics = (permissions?: Permission[]) => {
  const probe = Permission.VIEW_ANALYTICS;
  return checkPermission(permissions, probe);
};

export const canManageUsersInWidget = (permissions?: Permission[]) => {
  const probe = Permission.WIDGET_USER_TABLE_MANAGE;
  return checkPermission(permissions, probe);
};

export const canEditAsset = (permissions?: Permission[]) => {
  const probe = Permission.EDIT_ASSET;
  return checkPermission(permissions, probe);
};

export const canDeleteAsset = (permissions?: Permission[]) => {
  const probe = Permission.DELETE_ASSET;
  return checkPermission(permissions, probe);
};

export const canCreateCustomVerificationType = (permissions?: Permission[]) => {
  const probe = Permission.CREATE_CUSTOM_VERIFICATION_TYPE;
  return checkPermission(permissions, probe);
};

export const canEditCustomVerificationType = (permissions?: Permission[]) => {
  const probe = Permission.EDIT_CUSTOM_VERIFICATION_TYPE;
  return checkPermission(permissions, probe);
};

export const canDeleteCustomVerificationType = (permissions?: Permission[]) => {
  const probe = Permission.DELETE_CUSTOM_VERIFICATION_TYPE;
  return checkPermission(permissions, probe);
};

export const canManageApiKeys = (permissions?: Permission[]) => {
  const probe = Permission.WIDGET_API_KEYS_MANAGE;
  return checkPermission(permissions, probe);
};
